import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { classNames } from "@utilscommon";
import { handleShowHide } from "@fieldshowhide";
import FixedFields from "@formfixedfield";
import FieldItem from "@formdynamicfield";
import LocaleStrings from "@language";

const OldFormPage = (props) => {
  const {
    autofill,
    formValues,
    btnLoading,
    formArray,
    pristine,
    invalid,
    submitting,
    lastFieldUpdated,
    allConditionalFields,
  } = props;
  // console.log("OldFormPage :- ", formArray);
  // console.log("allConditionalFields :- ", allConditionalFields);

  const renderFields = () => {
    // console.log("lastFieldUpdated :- ", lastFieldUpdated);
    // console.log("formValues :- ", formValues);

    let renderFieldsArr = [];
    for (let pi = 0; pi < formArray.length; pi++) {
      let field = formArray[pi];
      let name = field?.name;

      // let ishidden = handleShowHide(name);
      let ishidden = handleShowHide(
        name,
        formValues,
        autofill,
        lastFieldUpdated,
        allConditionalFields
      );

      // console.log("ishidden :- ", name, ishidden);
      // console.log("-------------------");

      if (ishidden === 0)
        renderFieldsArr.push(
          <FieldItem
            key={name}
            form={field}
            autofill={autofill}
            formValues={formValues}
          />
        );
    }

    // console.log("renderFieldsArr :- ", renderFieldsArr);
    return renderFieldsArr;
  };

  return (
    <>
      <div className="base-form">
        <FixedFields autofill={autofill} formValues={formValues} />

        {/* Checkout Fields */}
        {renderFields()}
      </div>

      {/* divider */}
      <div className="relative py-6">
        <div className="absolute inset-0 flex items-center" aria-hidden="true">
          <div className="w-full border-t border-gray-300" />
        </div>
      </div>
      {/* divider */}

      <div className="text-right">
        <button
          type="submit"
          className="theme-button-md"
          disabled={pristine || invalid || submitting || btnLoading}
        >
          <svg
            className={classNames(
              btnLoading ? "" : "hidden",
              "cust-btn-spinner"
            )}
            viewBox="0 0 1024 1024"
            focusable="false"
            data-icon="btnloading"
            width="1em"
            height="1em"
            fill="currentColor"
            aria-hidden="true"
          >
            <path d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"></path>
          </svg>{" "}
          {LocaleStrings.kRegisterText}
        </button>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    formArray: state.formArray,
    lastFieldUpdated: state.lastFieldUpdated,
    allConditionalFields: state.allConditionalFields,
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(OldFormPage);
